'use strict';

angular.module('shop').controller('ConfirmationController', function ($rootScope, $scope, $state, $stateParams, $window, $location, $timeout, PaymentService, CartService, TrackerService, CustomerService, LogService, $cookies, ShopService) {

	$scope.loading = true;	

	// Return to checkout if empty cart
	$scope.cart = ShopService.getCart();
	if (!$scope.cart || !$scope.cart.cartArticles || $scope.cart.cartArticles.length === 0) {
		$state.go('checkout');
	}

	CustomerService.get().then(function(customer){
		$scope.customer = customer;

		var orderId = $stateParams['order_id'];
		if (orderId) {
			$scope.klarnaOrder = true;

			PaymentService.klarnaSummary(orderId).then(function(checkoutSummary) {

				LogService.log($scope.customer, 'shop-checkout', 'Kund på bekräftelsesidan för ny order med Klarna order-id: ' + orderId);
	
				// Complete order in backend
				PaymentService.completeCheckout(checkoutSummary).then(function() {
					
					// Confirm order to backend
					$scope.cart.payDirect = true;
					ShopService.order($scope.cart);

					// Remove cart
					ShopService.removeCart();

					LogService.log($scope.customer.id, 'shop-checkout', 'Ny Order bekräftad med Klarna order-id: ' + orderId);
				}, function() {
					LogService.log($scope.customer.id, 'shop-checkout', 'Fel vid bekräftelse av order till flowCartAfterKCO med Klarna order-id: ' + orderId);
				});
	
				$scope.checkoutHtml = checkoutSummary['html_snippet'];
	
				var checkoutContainer = document.getElementById('my-checkout-container');
				checkoutContainer.innerHTML = $scope.checkoutHtml;
				var scriptsTags = checkoutContainer.getElementsByTagName('script');
				// This is necessary otherwise the scripts tags are not going to be evaluated
				for (var i = 0; i < scriptsTags.length; i++) {
					var parentNode = scriptsTags[i].parentNode;
					var newScriptTag = document.createElement('script');
					newScriptTag.type = 'text/javascript';
					newScriptTag.text = scriptsTags[i].text;
					parentNode.removeChild(scriptsTags[i]);
					parentNode.appendChild(newScriptTag);
				}
	
				$scope.loading = false;
			}, function() {
				LogService.log($scope.customer.id, 'shop-checkout', 'Det gick inte att initiera bekräftelsesidan för Klarna med order-id: ' + orderId);
			});
		} else {
			// Confirm order to backend
			$scope.cart.payDirect = false;
			ShopService.order($scope.cart);

			// Remove cart
			ShopService.removeCart();

			$scope.loading = false;
		}
	});	

	// Login customer
	if ($cookies.get('cart-token')) {
		$cookies.put('token', $cookies.get('cart-token'), {
			path: '/',
			expires: moment().add(1, 'year').toDate()
		});
		$cookies.remove('cart-token', {
			path: '/'
		});
	}
});
